import { QueryClient, useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { SpaEntityType } from 'shared-types/Spa';

export const getSpaTreatment = async (
  propertyId: number,
  language: string,
  spaTreatmentId: any,
  params: { arrivalDate: string | null; isTimeSlot?: number }
) => {
  const { data } = await request.get(`${propertyId}/spa-treatments/${spaTreatmentId}/${language}`, {
    params,
  });
  return data as SpaEntityType;
};

export const getSpaTreatmentPrefetch = async (
  queryClient: QueryClient,
  propertyId: number,
  language: string,
  spaTreatmentId: any,
  arrivalDate: string | null
) => {
  await queryClient.prefetchQuery(
    getAvailableSpaTreatmentKey(
      propertyId,
      language,
      spaTreatmentId,
      {
        arrivalDate,
      },
      false
    ),
    () =>
      getSpaTreatment(propertyId, language, spaTreatmentId, {
        arrivalDate,
        isTimeSlot: arrivalDate ? 1 : undefined,
      }),
    { cacheTime: Infinity, staleTime: Infinity }
  );
};

export const useGetSpaTreatment = (
  propertyId: number,
  language: string,
  spaTreatmentId: any,
  arrivalDate: string | null,
  enabled = true,
  showUnpublished = false
) => {
  const { data, isFetching } = useQuery({
    queryKey: getAvailableSpaTreatmentKey(
      propertyId,
      language,
      spaTreatmentId,
      {
        arrivalDate,
      },
      showUnpublished
    ),
    queryFn: () =>
      getSpaTreatment(propertyId, language, spaTreatmentId, {
        arrivalDate,
        isTimeSlot: arrivalDate ? 1 : undefined,
        ...(showUnpublished ? { showUnpublished: 1 } : {}),
      }),
    cacheTime: Infinity,
    staleTime: Infinity,
    keepPreviousData: true,
    enabled,
  });
  return { data, isFetching };
};

export const getAvailableSpaTreatmentKey = (
  propertyId: number,
  language: string,
  spaTreatmentId: any,
  params: {
    arrivalDate: string | null;
  },
  showUnpublished: boolean
) => [
  'spaTreatment',
  'available',
  propertyId,
  parseInt(spaTreatmentId, 10),
  ...Object.values(params),
  language,
  showUnpublished,
];
